import "./styles.css";
import React from "react";
import { FaArrowRight, FaBuilding, FaIdCard } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { usePentagovContext } from "../../context/pentagovContext";

const ListaClientes = ({ lista, maxHeight }) => {
  const navigate = useNavigate();
  const { setIDClienteAberto } = usePentagovContext();

  const handleCardClick = (id) => {
    setIDClienteAberto(id);
    navigate(`/Servicos/${id}`);
  };

  return (
    <div
      className="card-container"
      style={{
        maxHeight: maxHeight || "65vh",
        overflowY: "auto",
      }}
    >
      {lista.map((cliente) => (
        <div
          key={cliente.IDCliente}
          className="card-cli"
          onClick={() => handleCardClick(cliente.IDCliente)}
        >
          <div className="card-content">
            <div className="card-cli__header">
              <div>
                <span className="card-cli__eyebrow">Cliente</span>
                <h3>
                  <FaBuilding />
                  {cliente.nome}
                </h3>
              </div>
              <span className="card-cli__action">
                Abrir <FaArrowRight />
              </span>
            </div>
            <div className="card-cli__meta">
              <FaIdCard />
              <span>CNPJ: {cliente.cnpj}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListaClientes;
